const fetchCORs = (url, options = {}) => {
  const opts = { ...options, mode: "cors" };
  return fetch(url, opts);
};

export default fetchCORs;
